import { Box, Chip, Group, ScrollArea, Stack } from "@mantine/core";

type Props = {
  active: string;
  setActive: (value: string) => void;
  hideService?: boolean;
};

function HeaderSection({ active, setActive, hideService = false }: Props) {
  return (
    <Stack px="md">
      <Chip.Group
        value={active}
        onChange={(value) => setActive(value as string)}
      >
        <ScrollArea>
          {/* ids are the add-member tour's anchors */}
          <Group wrap="nowrap" id="team-add-steps" w="fit-content">
            <Chip

              value="1"
              styles={{
                label: {
                  padding: "20px",
                },
                iconWrapper: {
                  display: "none",
                },
              }}
            >
              اطلاعات فردی
            </Chip>
            {!hideService && (
              <Box id="team-add-step-services">
              <Chip

                value="2"
                styles={{
                  label: {
                    padding: "20px",
                  },
                  iconWrapper: {
                    display: "none",
                  },
                }}
              >
                خدمات
              </Chip>
              </Box>
            )}

            <Chip
              value="3"
              color="dark"
              styles={{
                label: {
                  padding: "20px",
                },
                iconWrapper: {
                  display: "none",
                },
              }}
            >
              تنظیمات
            </Chip>
          </Group>
        </ScrollArea>
      </Chip.Group>
    </Stack>
  );
}

export default HeaderSection;
